import { render, staticRenderFns } from "./ReportErrorMessage.vue?vue&type=template&id=a20bdc54&scoped=true&"
import script from "./ReportErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ReportErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReportErrorMessage.vue?vue&type=style&index=0&id=a20bdc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20bdc54",
  null
  
)

export default component.exports